import { useState, useEffect, useCallback } from 'react'

const DEFAULT_DEBOUNCE_MS = 300

export function useCollectionSearch(
  initialValue: string = '',
  onSearch: (value: string) => void,
  debounceMs: number = DEFAULT_DEBOUNCE_MS
) {
  const [inputValue, setInputValue] = useState(initialValue)

  // Sync input with external value changes (e.g., from URL)
  useEffect(() => {
    setInputValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(inputValue)
    }, debounceMs)
    return () => clearTimeout(timer)
  }, [inputValue, onSearch, debounceMs])

  const handleChange = useCallback((value: string) => {
    setInputValue(value)
  }, [])

  const handleClear = useCallback(() => {
    setInputValue('')
    onSearch('')
  }, [onSearch])

  return {
    inputValue,
    handleChange,
    handleClear,
  }
}
